module.exports = __webpack_public_path__ + "media/images/flags/sx-61a887f300f8d186c6ffea7eeff094e9.svg";